import { Checkbox } from '@mui/material'
import useStyles from './useStyles'

function TableHeader ({ toggleAll, allChecked, indeterminate }) {
  const classes = useStyles()
  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCheck}>
          <Checkbox />
        </th>
        <th className={classes.headNumber}>Nro. de suscriptor </th>
        <th className={classes.headName}>Razón social</th>
        <th className={classes.headCreateUser}>Creado por</th>
        <th className={classes.headMaxUser}>Máx. usuarios</th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
